export const POST_EMAIL_CONFIRMATION_KEY = 'POST_EMAIL_CONFIRMATION_KEY';
